import { Page } from "@core/components/layout/page";
import { FamilyGoalsSummarySection } from "@crm/components/families/family-goals-summary-section";
import { FamilyOverviewEmpty } from "@crm/components/families/family-overview-empty";
import { FamilyOverviewMetrics } from "@crm/components/families/family-overview-metrics";
import {
  FamilyAssetAllocationSection,
  FamilyProductsSection,
} from "@crm/components/families/family-products-section";
import { FamilyRecentActivitySection } from "@crm/components/families/family-recent-activity-section";
import { FamilyReportsSection } from "@crm/components/families/family-reports-section";
import { useFamilyHasHoldings } from "@crm/hooks/use-family-holdings";
import { FamilySource } from "creso-core/types";
import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, V2Loader } from "web-design-system";

export function FamilyOverview() {
  const [sourceType, setSourceType] = useState<FamilySource>("OVERALL");
  const hasHoldings = useFamilyHasHoldings();

  return (
    <>
      <Page.Header title="Overview" className="top-0" />
      <Page.Body>
        <V2Loader isLoading={hasHoldings === undefined}>
          {hasHoldings === false ? (
            <FamilyOverviewEmpty />
          ) : (
            <div className="flex flex-col gap-6 pb-8">
              <Tabs
                value={sourceType}
                onValueChange={(value) => setSourceType(value as FamilySource)}
                className="mb-2"
              >
                <TabsList>
                  <TabsTrigger value="OVERALL">All</TabsTrigger>
                  <TabsTrigger value="INTERNAL">Internal</TabsTrigger>
                  <TabsTrigger value="EXTERNAL">External</TabsTrigger>
                </TabsList>
              </Tabs>
              <FamilyOverviewMetrics source={sourceType} />
              <FamilyAssetAllocationSection source={sourceType} />
              <FamilyProductsSection source={sourceType} />
              <div className="bg-border w-full h-px" />
              <FamilyGoalsSummarySection />
              <FamilyReportsSection />
              <FamilyRecentActivitySection />
            </div>
          )}
        </V2Loader>
      </Page.Body>
    </>
  );
}
